import {observable, action, runInAction} from 'mobx'
import { PAGE_SIZE_DEFAULT } from '../constants/appConstant';
import reportTagAPI from '../apis/reportTagAPI'
import alertMessage from '../utils/alertMessage'

export default class ReportTagStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT;
  @observable pageNo = 1;
  @observable currIndex = 0
  @observable itemCount = 0;
  /*SearchResult start*/
  @observable searchItem = {
    tagName: '',
  }
  @observable tagList = []

  @action
  async onGetReportTagList(params) {
    this.isFetching = true
    this.pageNo = params.pageNo;
    this.pageSize = params.pageSize;
    this.itemCount = 0
    this.tagList = []
    try {
      this.searchItem = params
      const response = await reportTagAPI.getReportTagList(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.tagList = response.data.data?.list || []
          this.itemCount = response.data.data?.total
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async saveReportTag(params) {
    try {
      const response = await reportTagAPI.saveReportTag(params)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
          alertMessage.success(`Save Success！`)
          this.onGetReportTagList(this.searchItem)
        } else {
          alertMessage.error(`Save Failed！` + message)
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
    }
  }

  @action
  async deleteReportTag(id) {
    try {
      const response = await reportTagAPI.deleteReportTag(id)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
          alertMessage.success(`Delete Success！`)
          this.onGetReportTagList(this.searchItem)
        } else {
          alertMessage.error(`Delete Failed！` + message)
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return;
    }
    runInAction(() => {
      this.pageNo = pageNo;
      this.pageSize = pageSize;
    });
    this.onGetReportTagList({ ...this.searchItem, pageNo, pageSize })
  }
}